import { render } from "./LargeScreenGalleryLayout.vue?vue&type=template&id=20671e34"
import script from "./LargeScreenGalleryLayout.vue?vue&type=script&lang=js"
export * from "./LargeScreenGalleryLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__